// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Pvz4","alert":"SettungsInbox_alert__3UeVq"};